
export default {
  props: {
    field: {
      required: true,
      validator: v => v == null || typeof v == "object",
    },
  },
};
